import { Action } from "@eusoft/webapp-ui/components/Action";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import { context } from "../services/Context"
import "./ContextView.scss";
import { selectContextAsync } from "../actions/Common";
import { app } from "@eusoft/webapp-framework/App";
import type { IContextSelectorArgs } from "../pages/ContextSelectorPage";
import { Icons } from "../entities/Icons";

interface IContextViewOptions {

}

export interface IContextInfo {

    hideContext?: boolean;

    hideBottomNav?: boolean;
}

export function ContextView(options: IContextViewOptions) {

    const state = context;

    const editContext = () => {

        const feature = app.contentHost.content?.features?.find(a => "type" in a && a.type == "WithContext");

        return selectContextAsync(feature?.data as IContextSelectorArgs ?? ({
            type: "sale-circuit",
        }));
    }
  
    return <div className="context-view" >
        <div className="main">
            <div className="sale-circuit">{Icons["sale-circuit"]} {state.saleCircuit?.name}</div>
            {state.merchant && <div className="merchant">{Icons["merchant"]}{state.merchant?.name}</div>}
            {state.salePoint && <div className="sale-point">{Icons["sale-point"]}{state.salePoint?.name}</div>}
            {state.operator && <div className="operator"><MaterialIcon name="person" />{state.operator?.name}</div>}
        </div>
        <Action name="edit" type="local" style="icon" onExecuteAsync={editContext}>
            <MaterialIcon name="edit"/>
        </Action>
    </div>
}